import $ from 'jquery';
import {Swiper, Navigation, Autoplay, Lazy} from 'swiper';
Swiper.use([ Navigation, Autoplay, Lazy]);

const imageSwiper = new Swiper('.swiper-image', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: '.image-swiper-button-next',
        prevEl: '.image-swiper-button-prev',
    },
});

$('.swiper-gallery').each(function () {
    const $self = $(this);
    const gallerySlider = new Swiper(this, {
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,

        navigation: {
            nextEl: $self.closest('.slider-container').find('.image-swiper-button-next')[0],
            prevEl: $self.closest('.slider-container').find('.image-swiper-button-prev')[0],
        }
    });
});
